module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.telaEhMobile) ? _c('field-validation', {
    attrs: {
      "label": _vm.rotulo,
      "field": _vm.nome,
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    staticClass: "form-control sem-espaco-dir",
    attrs: {
      "type": "date",
      "name": _vm.nome,
      "id": _vm.nome,
      "data-vv-as": _vm.rotulo,
      "v-validate": _vm.validacao,
      "max": _vm.dataMaxima,
      "min": _vm.dataMinima,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.valorDaData
    },
    on: {
      "input": function($event) {
        return _vm.valorDoInput($event.target.value)
      }
    }
  })]) : _c('field-validation', {
    attrs: {
      "label": _vm.rotulo,
      "field": _vm.nome,
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validacao),
      expression: "validacao"
    }],
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "name": _vm.nome,
      "id": _vm.nome,
      "config": _vm.config,
      "data-vv-as": _vm.rotulo,
      "value": _vm.valorDaData
    },
    on: {
      "input": function($event) {
        return _vm.valorDoInput($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b78b1c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campo-calendario/index.vue
// module id = HJFU
// module chunks = 5